var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var TwitterLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.275 20.262c7.552 0 11.682-6.258 11.682-11.681 0-.18 0-.358-.009-.528A8.411 8.411 0 0 0 22 5.924a8.333 8.333 0 0 1-2.358.647 4.103 4.103 0 0 0 1.805-2.273 8.315 8.315 0 0 1-2.606.996A4.086 4.086 0 0 0 15.844 4a4.106 4.106 0 0 0-4.104 4.104c0 .323.034.638.111.936a11.647 11.647 0 0 1-8.463-4.29 4.119 4.119 0 0 0-.554 2.06c0 1.422.724 2.682 1.831 3.414a4.032 4.032 0 0 1-1.856-.51v.05a4.11 4.11 0 0 0 3.295 4.027 4.091 4.091 0 0 1-1.856.069 4.1 4.1 0 0 0 3.831 2.852A8.253 8.253 0 0 1 2 18.406a11.438 11.438 0 0 0 6.275 1.856Z",
    fill: "currentColor"
  }));
});
TwitterLg.displayName = "TwitterLg";
export default TwitterLg;